"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const parseAmount = (amount) => {
    return Number(amount.replace(/[^\d.]/g, ''));
};
exports.default = parseAmount;
